import { render, staticRenderFns } from "./FormTextarea.vue?vue&type=template&id=7bf0e83a&"
import script from "./FormTextarea.vue?vue&type=script&lang=js&"
export * from "./FormTextarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports